module.exports = __webpack_public_path__ + "img/cepin.bcae59f3.png";